import { useEffect, useCallback, useRef } from 'react'
import { sendEvent } from '@/shared/hooks/use-analytics'

interface UseRentersStepOnePageOptions {
  onContinue: () => void
}

export function useRentersStepOnePage({
  onContinue,
}: UseRentersStepOnePageOptions) {
  const hasFired = useRef(false)

  useEffect(() => {
    if (hasFired.current) return
    hasFired.current = true
    sendEvent('ob_renters_started')
  }, [])

  const handleContinue = useCallback(() => {
    onContinue()
  }, [onContinue])

  return { handleContinue }
}
